import {createApp, defineAsyncComponent} from 'vue'
import store from './store'
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import "vue-awesome-paginate/dist/style.css";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {getCookie} from "@/utils/Cookie";
import * as is from 'is_js'
import VueAwesomePaginate from "vue-awesome-paginate";
import responsiveTextarea from "@/utils/ResponsiveTextareas";
import inputMaskDirective from "@/utils/inputMask";
import { createYmaps } from 'vue-yandex-maps';

const isDesktop = is.desktop()
const vueObject = {
    components: {
        CitySelect: defineAsyncComponent({
            loader: () => import('./components/utils/CitySelect')
        }),
        ContactsMap: defineAsyncComponent({
            loader: () => import('./components/utils/ContactsMap')
        }),
        FaqMain: defineAsyncComponent({
            loader: () => import('./components/Faq/Faq')
        }),
        ContractReissueForm: defineAsyncComponent({
            loader: () => import('./components/Forms/ContractReissueForm')
        }),
        FaqForm: defineAsyncComponent({
            loader: () => import('./components/Faq/FaqForm')
        }),
        CookieComponent: defineAsyncComponent({
            loader: () => import('./components/utils/CookieComponent')
        }),
        PromoEstimateForm: defineAsyncComponent({
            loader: () => import('./components/Forms/PromoEstimateForm')
        }),
        QuestionForm: defineAsyncComponent({
            loader: () => import('./components/Forms/QuestionForm')
        }),
        AboutForm: defineAsyncComponent({
            loader: () => import('./components/Forms/AboutForm')
        }),
        VacancyAskForm: defineAsyncComponent({
            loader: () => import('./components/Forms/VacancyAskForm')
        }),
        SubscribeForm: defineAsyncComponent({
            loader: () => import('./components/Forms/SubscribeForm')
        }),
        PayForm: defineAsyncComponent({
            loader: () => import('./components/Forms/PayForm')
        }),
        PopupHelp: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupHelp')
        }),
        PopupPromo: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupPromo')
        }),
        PopupEstimateForm: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupEstimateForm')
        }),
        PopupDirectorAsk: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupDirectorAsk')
        }),
        PopupVacancy: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupVacancy')
        }),
        PopupSuccess: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupSuccess')
        }),
        PopupMoneyDelivery: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupMoneyDelivery')
        }),
        PopupWelcome: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupWelcome')
        }),
        PopupPawnQuestion: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupPawnQuestion')
        }),
        PopupPawnReview: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupPawnReview')
        }),       
        PopupPawnBook: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupPawnBook')
        }),
        PopupBlock: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupBlock')
        }),
        PopupGamePage: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupGamePage')
        }),
        PopupPhotoSearch: defineAsyncComponent({
            loader: () => import('./components/Popups/PhotoSearch/PopupPhotoSearch.vue')
        }),
        PopupEstimatePignus: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupEstimatePignus.vue')
        }),
        PopupGame: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupGame')
        }),
        PopupGameSelect: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupGameSelect')
        }),
        PopupWinPromocode: defineAsyncComponent({
            loader: () => import('./components/Popups/PopupWinPromocode')
        }),
        PawnsMain: defineAsyncComponent({
            loader: () => import('./components/Pawnshops/PawnshopsMain')
        }),
        PawnshopsRouteBtn: defineAsyncComponent({
            loader: () => import('./components/Pawnshops/PawnshopsRouteBtn')
        }),
        CatalogFilter: defineAsyncComponent({
            loader: () => import('./components/Catalog/CatalogFilter')
        }),
        Catalog: defineAsyncComponent({
            loader: () => import('./components/Catalog/CatalogCatalog')
        }),
        CatalogItem: defineAsyncComponent({
            loader: () => import('./components/Catalog/CatalogItem')
        }),
        CatalogList: defineAsyncComponent({
            loader: () => import('./components/Catalog/CatalogList')
        }),
        CatalogSliderList: defineAsyncComponent({
            loader: () => import('./components/Catalog/CatalogSliderList')
        }),
        CatalogFavoritesList: defineAsyncComponent({
            loader: () => import('./components/Catalog/CatalogFavoritesList')
        }),
        PopupBuyClick: defineAsyncComponent({
            loader: () => import('./components/Catalog/PopupBuyClick')
        }),
        BasicLoader: defineAsyncComponent({
            loader: () => import('./components/utils/BasicLoader')
        }),
        PaginationList: defineAsyncComponent({
            loader: () => import('./components/utils/PaginationList')
        }),
        CartPreview: defineAsyncComponent({
            loader: () => import('./components/Cart/CartPreview')
        }),
        CartProducts: defineAsyncComponent({
            loader: () => import('./components/Cart/CartProducts')
        }),
        CartPayment: defineAsyncComponent({
            loader: () => import('./components/Cart/CartPayment.vue')
        }),
        CartOrder: defineAsyncComponent({
            loader: () => import('./components/Cart/CartOrder/CartOrder')
        }),
        CartHeaderLinks: defineAsyncComponent({
            loader: () => import('./components/Cart/CartHeaderLinks.vue')
        }),
        AppSimple: defineAsyncComponent({
            loader: () => import('./components/utils/AppSimple.vue')
        }),
        InputMask: defineAsyncComponent({
            loader: () => import('./components/utils/InputMask.vue')
        }),
        InputPhone: defineAsyncComponent({
            loader: () => import('./components/utils/InputPhone.vue')
        }),
        InputFile: defineAsyncComponent({
            loader: () => import('./components/utils/InputFile.vue')
        }),
        Multiselect : defineAsyncComponent({
            loader: () => import('@vueform/multiselect')
        }),
        InputText : defineAsyncComponent({
            loader: () => import('./components/utils/InputText.vue')
        }),
        InputSelect : defineAsyncComponent({
            loader: () => import('./components/utils/InputSelect.vue')
        }),
    },
    async created() {
        if (!getCookie('FIA_LOCATION_DATA') || !isDesktop) {
            await this.loadUserLocation()
        } else {
            this.setUserLocation({
                lat: JSON.parse(getCookie('FIA_LOCATION_DATA')).lat,
                lon: JSON.parse(getCookie('FIA_LOCATION_DATA')).lon
            })
            if (getCookie('FIA_CITY_DATA')) {
                this.setUserCity(JSON.parse(getCookie('FIA_CITY_DATA')))
            } else {
                await this.loadClosestCity()
            }
        }

        await this.loadPreScoreInitials()
        await this.loadCitiesList()
        await this.loadDocuments()
        
        if(location.pathname.includes('/catalog/')) {
            this.loadFavorites();
            this.loadCartData();
        }
     
        this.showPopupPayLoan();
        if (window.location.hash == '#help-popup') {
            this.showPopupHelp();
        }
        if (window.location.hash == '#ocenka-popup') {
            this.showPopupLoan('full');
        }
        // if(window.location.pathname !== '/game/' && !localStorage.getItem('popup-game') && window.location.host === "fianitlombard.ru") {
        //     setTimeout(() => {
        //         this.openModal('game-select')
        //         localStorage.setItem('popup-game', true)
        //     }, 50000)
        // }
        
        // Открытие новых модалок если в хэше есть #modal
        if (window.location.hash.includes('#modal')) {
            this.openModal(window.location.hash.replace('#modal-', ''))
        }
    },
    computed: {
        ...mapGetters({
            getCartData: 'catalog/getCartData',
            getPopupWelcome: 'getPopupWelcome',
        }),
        location : () => window.location,
    },
    methods: {
        ...mapActions({
            loadPreScoreInitials: 'estimate/loadPreScoreInitials',
            loadUserLocation: 'location/loadUserLocation',
            loadClosestCity: 'location/loadClosestCity',
            loadCitiesList: 'location/loadCitiesList',
            loadDocuments: 'loadDocuments',
            openPopupEstimate: 'estimate/openPopupEstimate',
            loadFavorites: 'catalog/loadFavorites',
            loadCartData: 'catalog/loadCartData',
            openModal: 'modals/openModal',
			closeModal: 'modals/closeModal',
        }),
        ...mapMutations({
            setUserLocation: 'location/setUserLocation', 
            setUserCity: 'location/setUserCity',
            setPopupHelpData: 'setPopupHelpData',
            setPopupPromoData: 'setPopupPromoData'
        }),
        alert (message, status = 'success') {
            if (status == 'success') {
                window.toast ? window.toast.success(message) : null;
            }
        },
        showPopupPayLoan() {
            if (
                window.location.hash == '#pay-popup' ||
                window.location.pathname === '/personal/' && (new URL(document.location)).searchParams.get('payDept') == 'Y'
            ) {
                window.fancyboxConstructor.show([{src: "#pay-popup", type: 'inline'}], {
                    Toolbar: false,
                    dragToClose: false,
                    Thumbs: false,
                    closeButton: "top",
                    mainClass: "fancybox-loan",
                    autoFocus: false,
                    trapFocus: false,
                    click: (fancybox) => {
                        fancybox.close()
                    }
                });
            }
        },
        showPopupHelp() {
            window.fancyboxConstructor.show([{src: "#question-form", type: 'inline'}], {
                Toolbar: false,
                dragToClose: false,
                Thumbs: false,
                closeButton: "outside",
                autoFocus: false,
                mainClass: "fancybox-modal",
                showClass: "fancybox-zoomIn",
                hideClass: "fancybox-zoomOut",
                trapFocus: false,
                click: (fancybox) => {
                    fancybox.close()
                }
            });
        },
        showPopupLoan(mode = 'full') {
            this.openPopupEstimate({mode});
        }
    }
};

window.addEventListener('DOMContentLoaded', () => {
    const app = createApp(vueObject);

    app
        .use(store)
        .use(VCalendar, {})
        .use(VueAwesomePaginate)
        .use(createYmaps({
            apikey: '124db383-e7af-4d09-9bfb-cdabba0d7a65',
        }))
        .directive('mask', inputMaskDirective)
        .directive('respHeight', responsiveTextarea)
        .mount('#fianit-vue');

    if (window.initUI) window.initUI();
})

